import gql from 'graphql-tag';

const DELETE_MILESTONE = gql`
  mutation deleteMilestone($where: MilestoneWhereUniqueInput!) {
    deleteMilestone(where: $where) {
      id
      name
    }
  }
`;

export default DELETE_MILESTONE;
